import styled, { css } from "styled-components";
import { primaryColor } from "../dash/styles";

export const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
`;



